// src/pages/duelChartEngineContext.js
// Chart-engine context for the Arena screens, kept free of any chart
// imports so App.js can wrap the duel/challenge routes without pulling
// Highcharts or lightweight-charts into the main bundle. EMB-06: the default
// is now 'tv' (Aurora via TVChartCompat) so DuelTradeReview's TradeReviewPanel,
// which the journal reuses (/app calendar popup in InvestmentsGrid, Playbook,
// backtesting), also renders on Aurora. 'highcharts' remains selectable via
// <DuelChartEngineProvider value="highcharts">.
import React, { createContext, useContext } from 'react';
import { Outlet } from 'react-router-dom';

const DuelChartEngineContext = createContext('tv');

export function DuelChartEngineProvider({ value, children }) {
  return <DuelChartEngineContext.Provider value={value}>{children}</DuelChartEngineContext.Provider>;
}

export function useDuelChartEngine() {
  return useContext(DuelChartEngineContext);
}

// Layout route: every child route renders its duel screens on TVChart.
export function TVChartRoutes() {
  return <DuelChartEngineProvider value="tv"><Outlet /></DuelChartEngineProvider>;
}
